import React from "react";
import Navbar from "./Navbar";

function ManagerHome() {
    return(
        <>
        <Navbar />
        <div className="card" style={{backgroundColor:'gainsboro',position:'relative',top:'50px'}}>
            <h2 >Manager Home</h2>
        </div>
        </>
    );
}
export default ManagerHome;